exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field[data-v-1fb1fa04] {\n  margin-top: 20px;\n}\n.field label[data-v-1fb1fa04] {\n  font-size: 14px;\n  font-weight: 500;\n}\n.error-message[data-v-1fb1fa04] {\n  margin-top: 2px;\n  margin-left: 2px;\n  color: red;\n}\n.btn-icon[data-v-1fb1fa04] {\n  display: flex;\n  align-items: center;\n  padding: 7px 1px;\n}\n[data-v-1fb1fa04] .modal-dialog {\n  max-width: 500px;\n}", ""]);

// exports
